import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import {initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import CryptoService from "../../../services/crypto-service.js";

const UpdateCryptoImages = () => { 
  const [loading, setLoading] = useState(false);
  const [formData,setFormData] = useState({});
  const userData = useSelector(state => state.authReducer);
  const [errors, setErrors] = useState({ ...initialErrors });
  const navigate = useNavigate();
  const { id } = useParams();

  const [role,setUserRole] = useState();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('per_details');
  const [activeTab2, setActiveTab2] = useState('per_details2');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  }
  const validateField = (fieldName, value) => {
    let errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };

  const updateCryptoConfig = (e) => {
    e.preventDefault();
    let requiredFields = ['buyRate','sellRate','minQty','maxQty'];
    if (!validateFields(requiredFields, formData)) {
        return
      } 
      let request = {
        buy_rate: formData.buyRate,
        sell_rate: formData.sellRate,
        min_quantity: formData.minQty, 
        max_quantity: formData.maxQty
      }
      CryptoService.updateCryptoConfigs(request,id)
          .then(response => {
            setLoading(false);
           
            navigate('/crypto-config')
            toast.success(MESSAGES.CONFIG_UPDATE)
          })
          .catch(error => {
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
  }
  const getCryptoConfigList = (e) => {
    setLoading(true);
    CryptoService.getCryptoconfig(id)
      .then(response => {
        let data = response.data.data
       setFormData({
        buyRate: data.buy_rate,
        sellRate: data.sell_rate,
        minQty: data.min_quantity, 
        maxQty: data.max_quantity
       })
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
   
  }
  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue) {
        validateField(fieldName, fieldValue || ''); 
        isValid = false;
      }
    });
    return isValid;
  };

    useEffect(() => {
        getCryptoConfigList()
      setUserRole(userData.user.data.role.role_code.toLowerCase())
      
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);


const setTab = (tab) => {
   
    setActiveTab(tab);
  };
  const setTab2 = (tab) => {
   
    setActiveTab2(tab);
  };


const back = () => {
    navigate('/crypto-config'); 
  }
return (
<>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
      <h4 className="updatename" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Update Crypto Files</h4>
      <div className="container" style={{backgroundColor: 'white', float:'left'}}>
      <ul className="nav nav-tabs" style={{'cursor':'pointer'}}>
        
        <li className="nav-item tbbtrn" >
          <a className={`nav-link active`} id="list_per_details">Agent</a>
        </li>
       
      </ul>
        
      <ul className="nav nav-tabs" style={{'cursor':'pointer'}}>
        
            <li className="nav-item tbbtrn" onClick={() => setTab('per_details')}>
              <a className={`nav-link ${activeTab==='per_details' ? 'active_tab1' : '' }`} id="list_per_details">ERC</a>
            </li>
            <li className="nav-item tbbtrn" onClick={() => setTab('address_details')}>
              <a className={`nav-link ${activeTab==='address_details' ? 'active_tab1' : '' }`} id="list_address_details">TRC</a>
            </li>
          </ul>
        <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
          <div className={`tab-pane ${activeTab === 'per_details' ? 'active' : 'fade'}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                <label>Upload Payment Proof</label>
                <br></br>
                <input style={{width: '250px', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name"/>
               
                </div>
          </div>
          </div>

          <div className={`tab-pane ${activeTab === 'address_details' ? 'active' : 'fade'}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                <label>Upload Payment Proof</label>
                <br></br>
                <input style={{width: '250px', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name"/>
               
                </div>
          </div>
          </div>
          </div>
          
          <ul className="nav nav-tabs" style={{'cursor':'pointer', width:'100%'}}>
        
                <li className="nav-item tbbtrn">
                <a className={`nav-link active`} id="list_per_details">Merchant</a>
                </li>
       
        </ul>
          <ul className="nav nav-tabs" style={{'cursor':'pointer', width:'100%'}}>
            <li className="nav-item tbbtrn" onClick={() => setTab2('per_details2')}>
              <a className={`nav-link ${activeTab2==='per_details2' ? 'active_tab1' : '' }`} id="list_per_details">ERC</a>
            </li>
            <li className="nav-item tbbtrn" onClick={() => setTab2('address_details2')}>
              <a className={`nav-link ${activeTab2==='address_details2' ? 'active_tab1' : '' }`} id="list_address_details">TRC</a>
            </li>
          </ul>
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
          <div className={`tab-pane ${activeTab2 === 'per_details2' ? 'active' : 'fade'}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                <label>Upload Payment Proof</label>
                <br></br>
                <input style={{width: '250px', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name"/>
               
                </div>
          </div>
          </div>

          <div className={`tab-pane ${activeTab2 === 'address_details2' ? 'active' : 'fade'}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                <label>Upload Payment Proof</label>
                <br></br>
                <input style={{width: '250px', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name"/>
               
                </div>
          </div>
          </div>
          </div>
        </div>
      </div>
      
   
    </>
  );

}

 
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(UpdateCryptoImages));